var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('p',{staticClass:"headline"},[_vm._v("Thank you for participating in Workplace Health Assessment! Proceed to Lower Back Screening to complete your session.")])])}
var staticRenderFns = []

export { render, staticRenderFns }